import { createApp, markRaw } from 'vue'
import App from './App.vue'
import router from './router'
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import 'bootstrap/dist/js/bootstrap.js' //must be added for dropdowns to work
import 'bootstrap';
import '@popperjs/core'
import { createPinia } from 'pinia';
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'



//make router aviable in all stores
const pinia = createPinia()

pinia
.use(({ store }) => {
    store.router = markRaw(router)
})
.use(piniaPluginPersistedstate)


createApp(App)
    .use(pinia)
    .use(router)
    .mount('#app')
